import { Cookie } from "./Cookie";
import { segmentTrack } from "./segment/segment-track";

export const trialSignupEmailStepCompleted = (
  ctaText: string,
  email: string
) => {
  const url = window.location.pathname;

  segmentTrack("Lead Captured", {
    lead_type: "email",
    text: ctaText,
    url,
    email,
    object: "Lead",
    source_application: "Marketing",
    action: "Captured",
    ttclid: Cookie.getCookie("ttclid") || null,
    rdt_cid: Cookie.getCookie("rdt_cid") || null,
    li_fat_id: Cookie.getCookie("li_fat_id") || null,
    msclkid: Cookie.getCookie("msclkid") || null,
    fbclid: Cookie.getCookie("fbclid") || null,
    fcb: Cookie.getCookie("_fbc") || null,
    gclid: Cookie.getCookie("gclid") || null,
    utm_source: sessionStorage.getItem("utm_source") || null,
    utm_medium: sessionStorage.getItem("utm_medium") || null,
    utm_campaign: sessionStorage.getItem("utm_campaign") || null,
  });

  window.analytics?.identify({
    account_status: "lead",
    email,
  });
};
